import request from '../utils/request';

// 创建地区
export const createRegion = (data) => {
  return request({
    url: '/region/create',
    method: 'post',
    data
  });
};

// 更新地区
export const updateRegion = (data) => {
  return request({
    url: '/region/update',
    method: 'put',
    data
  });
};

// 删除地区
export const deleteRegion = (id) => {
  return request({
    url: `/region/delete/${id}`,
    method: 'delete'
  });
};

// 分页查询地区
export const getRegionList = (params) => {
  console.log("获取地区列表",params);
  return request({
    url: '/region/page',
    method: 'post',
    data:params
  });
};

// 获取地区树状列表
export const getRegionTree = () => {
  return request({
    url: '/region/tree',
    method: 'get'
  });
};

// 导入Excel文件
export const importExcel = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return request({
    url: '/region/import-excel',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
